/* eslint-disable react/no-array-index-key */
import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import { P, Link } from './styles';

const Text = ({ children, className }) => (
  <P className={className}>
    {typeof children === 'string' && children}
    {Array.isArray(children) &&
      children.map((item, key) => (
        <Fragment key={key}>
          {typeof item === 'string' && item}
          {typeof item === 'object' && (
            <Link href={item.url} target="_blank" rel="noopener noreferrer">
              {item.name}
            </Link>
          )}
        </Fragment>
      ))}
  </P>
);

Text.defaultProps = { children: '', className: '' };
Text.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.arrayOf(
      PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.shape({
          url: PropTypes.string.isRequired,
          name: PropTypes.string.isRequired,
        }),
      ]).isRequired
    ),
  ]),
  className: PropTypes.string,
};

export default Text;
